/**
 * useMyStation - Get the current user's packing station assignment
 *
 * Returns the station name and routing rules for the current user.
 * Returns null if user is not assigned to any station.
 * Only queries when locationId is available.
 */

import { trpc } from '@/lib/trpc';

export function useMyStation(locationId: string | null) {
  const query = trpc.stations.getMyStation.useQuery(
    { locationId: locationId! },
    {
      enabled: !!locationId,
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    }
  );

  return {
    station: query.data ?? null,
    skipVerification: query.data?.skipVerification ?? false,
    isLoading: query.isLoading,
  };
}
